import React, {useRef, useState, Children} from "react";
import PropTypes from "prop-types";
import Popper from "@material-ui/core/Popper";
import Fade from "@material-ui/core/Fade";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import {RMDButton} from "components/Shared";

const FauxHeaderDropdown = ({
  title,
  children
}) => {
  const ref = useRef();
  const [open, setOpen] = useState(false);
  return (
  <div className={"FauxHeaderDropdown-Root"}>
    <div {...{ref}}>
      <RMDButton onClick={() => setOpen(!open)}>
        {title}
      </RMDButton>
    </div>
    <Popper
      {...{ open }}
      className={"FauxHeaderDropdown-Popper"}
      anchorEl={ref.current}
      placement={"bottom-end"}
      transition
      disablePortal
    >
      {({TransitionProps}) => (
        <Fade {...TransitionProps} timeout={350}>
          <div>
            <ClickAwayListener onClickAway={({ target }) => (ref.current && !ref.current.contains(target)) && setOpen(false)}>
              <div className={"FauxHeaderDropdown-Content"}>
                {Children.toArray(children).map((child, index) => (
                  <div key={index} className={"FauxHeaderDropdown-Child"}>
                    {child}
                  </div>
                ))}
              </div>
            </ClickAwayListener>
          </div>
        </Fade>
      )}
    </Popper>
  </div>
  );
};

FauxHeaderDropdown.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]), 
};

export default FauxHeaderDropdown;